export var ClientFormNames;
(function (ClientFormNames) {
    ClientFormNames["EDIT"] = "edit";
    ClientFormNames["ADD"] = "add";
    ClientFormNames["PROJECT"] = "project";
})(ClientFormNames || (ClientFormNames = {}));
